module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/left-picture-276550d138e682935fd844c76d5c7beb.png";